const formatWaitLabel = retryAfterSeconds => {
  const totalSeconds = Math.max(1, Number(retryAfterSeconds) || 60)
  if (totalSeconds < 60) {
    return totalSeconds === 1 ? "1 second" : `${totalSeconds} seconds`
  }
  const minutes = Math.ceil(totalSeconds / 60)
  return minutes === 1 ? "1 minute" : `${minutes} minutes`
}

const buildRateLimitFallback = (retryAfterSeconds, isAuth = true) => {
  const waitLabel = formatWaitLabel(retryAfterSeconds)
  return isAuth
    ? `Too many login attempts. Please try again after ${waitLabel}.`
    : `Too many requests. Please try again after ${waitLabel}.`
}

/**
 * Normalize API error payloads (app shape, express-rate-limit shape, axios errors).
 */
export const getApiErrorMessage = (payload, err, options = {}) => {
  const { isAuth = false, fallback = "" } = options
  const data =
    payload && typeof payload === "object"
      ? payload
      : err?.response?.data && typeof err.response.data === "object"
        ? err.response.data
        : null

  if (!data) {
    return fallback
  }

  const retryAfterSeconds =
    data.retryAfterSeconds ??
    (() => {
      const header = err?.response?.headers?.["retry-after"]
      const parsed = Number(header)
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null
    })()

  const text = data.msg || data.message
  if (text) {
    if (
      retryAfterSeconds &&
      !/try again after/i.test(String(text))
    ) {
      return buildRateLimitFallback(retryAfterSeconds, isAuth)
    }
    return String(text)
  }

  if (data.statusCode === 429 || retryAfterSeconds) {
    const fallbackSeconds =
      retryAfterSeconds ||
      (parseInt(process.env.REACT_APP_AUTH_RATE_LIMIT_WINDOW_MINUTES, 10) || 3) * 60
    return buildRateLimitFallback(fallbackSeconds, isAuth)
  }

  return fallback
}

export const isMaintenanceApiResponse = (errOrData, response) => {
  const status = response?.status ?? errOrData?.response?.status
  const data =
    errOrData?.maintenance !== undefined
      ? errOrData
      : errOrData?.response?.data
  return status === 503 && data?.maintenance === true
}
